import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=4949fe28&scoped=true"
import script from "./HomeHero.vue?vue&type=script&lang=js"
export * from "./HomeHero.vue?vue&type=script&lang=js"
import style0 from "./HomeHero.vue?vue&type=style&index=0&id=4949fe28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949fe28",
  null
  
)

export default component.exports